import React from "react";

const Info = () => {
  return <div className="about_info grid">
    <div className="about_box">
    <i class="fa-solid fa-award"></i>
        <h3 className="about_title">Completed</h3>
        <span className="about_subtitle">20 + Projects</span>
    </div>
    <div className="about_box">
    <i class="fa-solid fa-headset"></i>
         <h3 className="about_title">Support</h3>
        <span className="about_subtitle">Online 24/7</span>
    </div>
  </div>;
};

export default Info;
